import { Col, Dropdown, DropdownMenu, Row } from "react-bootstrap";
import { MyTodos } from "./taskboard/TaskboardTables/MyTodos";
import { MyFollowup } from "./taskboard/TaskboardTables/MyFollowup";
import { MyTask } from "./taskboard/TaskboardTables/MyTask";
import useLocalStorageState from "use-local-storage-state";
import { useEffect, useRef, useState } from "react";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import { Badge, Calendar, CheckSquare, ListTodo, LucideCalendar } from "lucide-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconCalendar, IconCalendarEvent, IconChevronDown, IconFilter, IconListCheck, IconPencilPlus } from "@tabler/icons-react";
import { useQueryClient } from "react-query";
import DatePicker from "react-datepicker"
import { useOutsideClickHandler } from "../../Utils/hooks/useOutsideClickHandler";
import { TaskBoardMeeting } from "./taskboard/TaskboardTables/TaskBoardMeeting";
import { useDebounce } from "../../Utils/helpers/commonhelper";
import { MyDashboard } from "./MyDashboard";
import AnalyticsDashboard from "./AnalyticsDashboard";
import SalesDashboard from "./SalesDashboard";


export const Dashboard = () => {
    const [customer, setCustomer] = useLocalStorageState('customer')
    const [customFrom, setCustomFrom] = useState("");
    const [customTo, setCustomTo] = useState("");
    const queryClient = useQueryClient();
    const [activeTab, setActiveTab] = useState('followup')
    const [filter, setFilter] = useState(`All ${activeTab === "followup" ? "Followup" : "Task"}`)
    const [showCustomInputs, setShowCustomInputs] = useState(false);
    // for opening dropdown
    const [dashboardSwitch, setDashboardSwitch] = useState(false);
    const [dashboardLabel, setDashboardLabel] = useState("My TaskBoard");
    const dashboardDropRef = useRef(null)

    // search state to search across myfollowup and mytask (maybe for todos and meetings as well not yer discussed)
    const [inputSearch, setInputSearch] = useState("")
    // a debounce function for inputsearch
    const debouncedInputSearch = useDebounce(inputSearch, 200)

    // permission setup for leads
    const permission = customer.customer_details?.permission

    // permission for lead
    const leadPermission = permission?.filter(c => c.module_name === "leads")
    const user_type = Number(customer.customer_details?.user_type)
    const leadGrant = {
        isView: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "leads")?.view)) : true,
        isCreate: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "leads")?.create)) : true,
        isEdit: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "leads")?.edit)) : true,
        isDelete: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "leads")?.delete)) : true,
    }
    const leadFollowupGrant = {
        isView: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "followup")?.view)) : true,
        isCreate: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "followup")?.create)) : true,
        isEdit: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "followup")?.edit)) : true,
        isDelete: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "followup")?.delete)) : true,
    }

    // permission for lead and deal
    const dealPermission = permission?.filter(c => c.module_name === "deals")
    // deals followupgrant
    const dealFollowupGrant = {
        isView: user_type !== 1 ? Boolean(Number(dealPermission?.find(c => c.feature_name === "followup")?.view)) : true,
        isCreate: user_type !== 1 ? Boolean(Number(dealPermission?.find(c => c.feature_name === "followup")?.create)) : true,
        isEdit: user_type !== 1 ? Boolean(Number(dealPermission?.find(c => c.feature_name === "followup")?.edit)) : true,
        isDelete: user_type !== 1 ? Boolean(Number(dealPermission?.find(c => c.feature_name === "followup")?.delete)) : true,
    }

    useOutsideClickHandler({
        objRef: dashboardDropRef,
        isDropdown: dashboardSwitch,
        setDropdown: setDashboardSwitch
    })

    return (
        <div className="dashboard-wrapper px-3 py-2" style={{ background: "#f8fafc", minHeight: "calc(100vh - 6rem)" }}>
            <div className=" d-flex flex-column rounded-4 py-2 mb-0 d-flex justify-content-between align-items-center ">
                <div className="d-flex align-items-center justify-content-between w-100 gap-1 rounded-3">
                    <div className="d-flex align-items-center gap-1 ">
                        <Dropdown show={dashboardSwitch} ref={dashboardDropRef}>
                            <button
                                type="button"
                                onClick={(e) => {
                                    e.stopPropagation()
                                    setDashboardSwitch(prev => !prev);
                                }}
                                className={`btn d-flex align-items-center gap-2 px-3 py-2 border-0 transition-all shadow-sm fw-medium`}
                                style={{
                                    borderRadius: '18px',
                                    fontSize: '14px',
                                    background: '#7a3a5e',
                                    color: "white"
                                }}
                            >
                                {dashboardLabel} <IconChevronDown size={16} />
                            </button>
                            <Dropdown.Menu style={{ zIndex: 999 }}>
                                <Dropdown.Item
                                    onClick={() => {
                                        setDashboardSwitch(false);
                                        setDashboardLabel('My Taskboard');
                                    }}
                                >
                                    My TaskBoard
                                </Dropdown.Item>
                                <Dropdown.Item
                                    onClick={() => {
                                        setDashboardSwitch(false);
                                        setDashboardLabel('CRM Dashboard');
                                    }}
                                >
                                    CRM Dashboard
                                </Dropdown.Item>
                                <Dropdown.Item
                                    onClick={() => {
                                        setDashboardSwitch(false);
                                        setDashboardLabel('Sales Dashboard');
                                    }}
                                >
                                    Sales Dashboard
                                </Dropdown.Item>
                                <Dropdown.Item
                                    onClick={() => {
                                        setDashboardSwitch(false);
                                        setDashboardLabel('Analytics Dashboard');
                                    }}
                                >
                                    Analytics Dashboard
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                        {

                            dashboardLabel?.toLowerCase()?.split(" ")?.join("_") === "my_taskboard" &&
                            <div className="d-flex gap-2 p-1 ">
                                {[
                                    { id: 'followup', label: 'Follow Ups', icon: <LucideCalendar size={16} /> },
                                    { id: 'task', label: 'My Tasks', icon: <CheckSquare size={16} /> },
                                    { id: 'todos', label: 'My Todos', icon: <IconListCheck size={18} /> },
                                    { id: 'meeting', label: 'Meetings', icon: <IconCalendarEvent size={18} /> }
                                ].map((tab) => (
                                    <button
                                        key={tab.id}
                                        onClick={() => {
                                            setActiveTab(tab.id);
                                            if (tab.id !== 'todos') setFilter(`All ${tab.id === "followup" ? "Followup" : "Task"}`);
                                        }}
                                        className={`btn d-flex align-items-center gap-2 px-3 py-2 transition-all ${activeTab === tab.id
                                            ? " shadow-sm  fw-medium"
                                            : "text-muted fw-medium border "
                                            }`}
                                        style={{
                                            borderRadius: '18px',
                                            fontSize: '14px',
                                            // color: activeTab === tab.id ? '#blc' : '#64748b',
                                            color: "black",
                                            borderColor: activeTab === tab.id ? '#7a3a5e' : '#64748b',
                                            // background: activeTab === tab.id ? '#7a3a5e' : 'white',
                                        }}
                                    >
                                        {tab.icon}
                                        {tab.label}
                                    </button>
                                ))}
                            </div>
                        }
                    </div>


                    {
                        dashboardLabel?.toLowerCase()?.split(" ")?.join("_") === "my_taskboard" &&
                        <div className=" position-relative " >
                            <input
                                type="text"
                                className="btn d-flex align-items-start border gap-2  py-2 transition-all"
                                style={{ fontSize: "0.87rem", fontWeight: 500, textAlign: "left", paddingLeft: "36px", height: '38px', borderRadius: "16px", background: "white" }}
                                value={inputSearch}
                                placeholder="Search Here...."
                                onChange={(e) => {
                                    e.preventDefault()
                                    setInputSearch(e.target.value)
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        e.preventDefault()
                                        setInputSearch(inputSearch)
                                    }
                                }}
                            />
                            <i
                                class="fa-solid fa-magnifying-glass"
                                style={{
                                    position: "absolute",
                                    marginTop: "-26px",
                                    zIndex: 1,
                                    marginLeft: "13px",
                                }}
                            ></i>
                            {inputSearch.length > 0 && (
                                <i
                                    class="fa-solid fa-xmark"
                                    style={{
                                        position: "absolute",
                                        marginTop: "-26px",
                                        zIndex: 1,
                                        right: 0,
                                        marginRight: "13px",
                                        cursor: "pointer",
                                    }}
                                // onClick={() => setInputSearch("")}
                                ></i>
                            )}
                        </div>

                    }
                </div>
            </div>
            <div className="content-container animate-fade-in" style={{ minHeight: "calc(100vh - 14rem)" }}>
                {console.log('label', dashboardLabel?.toLowerCase()?.split(" ")?.join("_"))}
                {dashboardLabel?.toLowerCase()?.split(" ")?.join("_") === "crm_dashboard" && <MyDashboard />}
                {dashboardLabel?.toLowerCase()?.split(" ")?.join("_") === "sales_dashboard" && <SalesDashboard />}
                {dashboardLabel?.toLowerCase()?.split(" ")?.join("_") === "analytics_dashboard" && <AnalyticsDashboard />}

                {activeTab === "followup" && dashboardLabel?.toLowerCase()?.split(" ")?.join("_") === "my_taskboard" && <MyFollowup filter={filter} customFrom={customFrom} customTo={customTo} searchInput={debouncedInputSearch} />}
                {activeTab === "task" && dashboardLabel?.toLowerCase()?.split(" ")?.join("_") === "my_taskboard" && <MyTask filter={filter} customFrom={customFrom} customTo={customTo} searchInput={debouncedInputSearch} />}
                {activeTab === "todos" && dashboardLabel?.toLowerCase()?.split(" ")?.join("_") === "my_taskboard" && (
                    <MyTodos />
                )}
                {activeTab === "meeting" && dashboardLabel?.toLowerCase()?.split(" ")?.join("_") === "my_taskboard" && <TaskBoardMeeting />}
            </div>

            <style>{`
                .transition-all { transition: all 0.2s ease-in-out; }
                .animate-fade-in { animation: fadeIn 0.3s ease-in-out; }
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(10px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                .btn-primary { background: #7a3a5e !important; }
                .text-primary { color: #7a3a5e !important; }
                .no-arrow::after { display: none !important; }
                .form-control:focus { border-color: #7a3a5e; box-shadow: 0 0 0 0.2rem rgba(122, 58, 94, 0.25); }
            `}</style>
        </div>
    );
}